import { Outlet, Link, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  AppBar,
  Typography,
  Box,
  useMediaQuery,
  IconButton,
  SwipeableDrawer,
  Avatar,
  ListSubheader,
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import { useContext, useState } from "react";
import { LOGIN_PAGE, logout } from "../api/auth";
import { GlobalContext } from "../globalComponents/context";

const menuItems = [
  { text: "Dashboard", path: "./" },
  { text: "Listar usuários", path: "./users" },
  { text: "Listar clientes", path: "./customers" },
  { text: "Listar produtos", path: "./products" },
  { text: "Listar prêmios", path: "./rewards" },
];

export default function Layout({ user }) {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { showConfirmDialog } = useContext(GlobalContext);

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  const handleLogout = () => {
    showConfirmDialog({
      title: "Logout",
      description: "Deseja mesmo sair?",
      onConfirm: () => logout(LOGIN_PAGE),
    });
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed" sx={{ zIndex: 1201 }}>
        <Toolbar>
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <Menu />
            </IconButton>
          )}
          <Avatar
            src="/logo-fideliza.png"
            sx={{ border: "2px solid #fff", background: "#fff" }}
          />
          &nbsp;
          <Typography
            style={{ lineHeight: 1 }}
            color="secondary"
            variant="h6"
            noWrap
            flexGrow={1}
          >
            JS Fideliza - Painel Admin <br />
            <small
              style={{  color: "#fff", fontWeight: 300 }}
            >
              {user.name}
            </small>
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Temporary Drawer for mobile */}
      <SwipeableDrawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        onOpen={() => {}}
        sx={{
          display: { xs: "block", sm: "none" }, // Only show on mobile
          width: 320,
        }}
      >
        <List subheader={<ListSubheader>Rotinas do sistema</ListSubheader>}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.text}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={handleDrawerToggle} // Close drawer on click
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </SwipeableDrawer>

      <Drawer
        variant="permanent"
        sx={{
          width: 320,
          [`& .MuiDrawer-paper`]: { width: 320, boxSizing: "border-box" },
          display: { xs: "none", sm: "block" }, // Hide on mobile
        }}
      >
        <Toolbar />
        <List subheader={<ListSubheader>Rotinas do sistema</ListSubheader>}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.text}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
          <ListItemButton onClick={handleLogout}>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </List>
      </Drawer>

      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0, // 🔥 critical fix
          padding: 2,
          background: "#faf8f7",
          overflow: "auto", // optional but recommended
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
